import { createInput } from "./createInput";

export const Input = createInput({});
